import React from 'react'
import './Loader.css'

const Loader = () => {
  return (

    <div className="loader ">
      <div className="loader-inner loading">
        <div className="loading-box">
          <div className="circular-loader">
          </div>		
        </div>
      </div>
      <div>
      </div></div>
  );
}

export default Loader